import { Component, OnInit, Input } from "@angular/core";
import { SharedService } from "../../services/shared.service";
import { Order } from "../../models/order.model";
import { TooltipDirective } from "../ui/tooltip.directive";
import { CommonModule } from "@angular/common";

@Component({
  selector: "order-stage-icon",
  templateUrl: "./order-stage-icon.component.html",
  styleUrls: ["./order-stage-icon.component.scss"],
  imports: [TooltipDirective, CommonModule],
  standalone: true,
})
export class OrderStageIconComponent implements OnInit {
  @Input() order: Order;

  constructor(private sharedService: SharedService) {}

  ngOnInit(): void {}

  getStageColor(): string {
    let color = this.sharedService.stageColors.find(
      (c) => c["stageId"] == this.order.stageId
    );
    if (!color) {
      return "#e8eff8";
    } else {
      return color["color"];
    }
  }
}
